import React from "react";
import ChangePasswordForm from "../components/ChangePassword";

export default function ChangePassword() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-4">
      <ChangePasswordForm />
    </div>
  );
}
